/* eslint-disable import/no-unresolved */
import {
  KlevuKMCSettings,
  KlevuConfig,
  KlevuFetch,
  trendingProducts,
  search,
} from 'https://cdn.skypack.dev/-/@klevu/core@v5.2.3-HNRf1HrJ9AqvnoHcX5mg/dist=es2019,mode=imports,min/optimized/@klevu/core.js'

// Original version, retained in case of issues due to high version bump
// https://cdn.skypack.dev/pin/@klevu/core@v1.1.5-0q1n6dBIy9DgOZifPmpX/mode=imports,min/optimized/@klevu/core.js
/* eslint-enable import/no-unresolved */

const config = {
  apiKey: `${window.theme.klevu.apiKey}`,
  url: `${window.theme.klevu.url}`,
}

KlevuConfig.init(config)

class KlevuSdk extends window.BAO.CustomElement() {
  async connectedCallback () {
    const searchField = this.externalEls.searchField
    const suggestionsData = await KlevuKMCSettings(true)
    const trendingProductsData = await KlevuFetch(
      trendingProducts({ limit: 8 }),
    )

    const map = suggestionsData.root.klevu_webstorePopularTerms
      .map(suggestion => {
        return `<li><button class="drw-SearchSuggestions_Trigger" type="button" data-search-drawer-el="suggestionValue" data-value="${suggestion}">'${suggestion}'</button></li>`
      })
      .join('')
    this.els.suggestionList.element.insertAdjacentHTML('afterbegin', map)

    const suggestionsFetched = new CustomEvent('klevuSuggestionsFetched')

    window.dispatchEvent(suggestionsFetched)

    const trendingProductsMap = trendingProductsData.apiResponse.queryResults[0].records
      .map(product => {
        return `<section-async class="prd-Card_Async" section-id="klevu-quick-product-card" url="${product.url}" aria-busy="true"></section-async>`
      })
      .join('')

    this.els.trendingProducts.element.insertAdjacentHTML(
      'afterbegin',
      trendingProductsMap,
    )

    this.listeners.add(searchField.element, 'input', evt => {
      this.searchRedirects(evt.target.value)
    })
  }

  async searchRedirects (searchTerm) {
    const resultObject = await KlevuFetch(
      search(searchTerm, {
        id: 'search',
      }),
    )

    const redirects =
      (await resultObject.queriesById('search').getRedirects?.()) || []

    if (redirects.length) {
      window.location.href = redirects[0].url
    }
  }
}

if (!customElements.get('klevu-sdk')) {
  customElements.define('klevu-sdk', KlevuSdk)
}
